/**
 * Loaded in index.html
 */
declare var analytics: {
  page: {
    pageData: {
      sitePrefix: string,
      pageAbort: string,
      interactionCategory: string,
      interactionDescription: string,
    }
  },
  component: {
    voiproperty: {
      pageCategory: string,
      pageDescription: string,
      notificationType: string,
    },
    form: {
      name: string,
      step: string,
      detail: string,
      referenceId: string,
      paymentAmount: string,
      paymentType: string,
      product: string,
      error: string
    }
  },
  user: {
    userData: {
      loginStatus: string
    }
  }
};

declare var _satellite: {
  track: (name: string) => void
};

/**
 * Adobe analytics can fail to load.
 * Don't want it crashing the UI
 */
const trackPageLoads = <T extends (trackData: string) => void>(td: T): T => {
  return ((trackData: string) => {
    try {
      resetAnalyticsValues();
      td(trackData);
      _satellite.track('voiproperty-navigate');
    } catch (e) {
      if (process.env.NODE_ENV !== 'test') {
        // tslint:disable-next-line:no-console
        console.error(e);
      }
    }
    // tslint:disable-next-line:no-any
  }) as any;
};


let resetAnalyticsValues = () => {
  let resetObjectsPropertyValues = (obj: Object): void => {
    for (let member in obj) {
      if (obj.hasOwnProperty(member)) {
        obj[member] = '';
      }
    }
  };
  analytics.page.pageData.interactionDescription = '';
  analytics.page.pageData.interactionCategory = '';
  resetObjectsPropertyValues(analytics.component.voiproperty);
  resetObjectsPropertyValues(analytics.component.form);
  analytics.user.userData.loginStatus = analytics.user.userData.loginStatus === 'authenticated'
    ? 'authenticated' : 'logged out';
};

export const trackLinkClick = (category: string, description: string) => {
      try {
        resetAnalyticsValues();
        analytics.page.pageData.interactionCategory = category;
        analytics.page.pageData.interactionDescription = description;
        _satellite.track('site-interact');
      } catch (e) {
        if (process.env.NODE_ENV !== 'test') {
          // tslint:disable-next-line:no-console
          console.error(e);
        }
      }
};


export const trackLandingPage = trackPageLoads(() => {
  analytics.component.voiproperty.pageCategory='diy';
  analytics.component.voiproperty.pageDescription='landing';
});

export const trackDashboardPage = trackPageLoads(() => {
  analytics.component.voiproperty.pageCategory='diy';
  analytics.component.voiproperty.pageDescription='dashboard';
});


export const trackRegisterPage = trackPageLoads(() => {
  analytics.component.voiproperty.pageCategory='diy';
  analytics.component.voiproperty.pageDescription='register:input details';
  analytics.component.form.name='diy register';
  analytics.component.form.step='input details';
  analytics.user.userData.loginStatus = 'authenticated';
});

export const trackRegisterVerifyPage = trackPageLoads(() => {
  analytics.component.voiproperty.pageCategory='diy';
  analytics.component.voiproperty.pageDescription='register:mobile verification';
  analytics.component.form.name='diy register';
  analytics.component.form.step='mobile verification';
});


export const trackDocumentSightingPage = trackPageLoads(() => {
  analytics.component.voiproperty.pageCategory='diy';
  analytics.component.voiproperty.pageDescription='register:document sighting';
  analytics.component.form.name='diy register';
  analytics.component.form.step='document sighting';
});

export const trackPaymentPage = trackPageLoads(() => {
  analytics.component.voiproperty.pageCategory='diy';
  analytics.component.voiproperty.pageDescription='register:payment';
  analytics.component.form.name='diy register';
  analytics.component.form.step='payment';
});

export function trackPaymentSuccessfulPage(category?:any , documents?:any, cost?:any, customerReferenceNumber?:any) {
  try {
    resetAnalyticsValues();
    analytics.component.voiproperty.pageCategory='diy';
    analytics.component.voiproperty.pageDescription='register:payment successful';
    analytics.component.form.name='diy register';
    analytics.component.form.step='payment successful';
    analytics.component.form.detail= `${category}${getDocument(documents)}`;
    analytics.component.form.referenceId = customerReferenceNumber;
    analytics.component.form.paymentAmount = cost;
    // analytics.component.form.paymentType
    //TODO get payment Type
    analytics.component.form.product = 'voi property transfers';
    _satellite.track('voiproperty-navigate');
  } catch (e) {
    if (process.env.NODE_ENV !== 'test') {
      // tslint:disable-next-line:no-console
      console.error(e);
    }
  }
};

export function getDocument(documents) {
  var files = '';
  var separator = ':';
  for (var orderFile of documents) {
    files += separator + orderFile.documentType;
  }
  return files.toLowerCase();
}

export const trackErrorPage = trackPageLoads((errorMsg) => {
  analytics.component.form.error=errorMsg;
});
